import { createContext } from "react";

export interface SEOProps {
  title: string;
  description: string;
  image?: string;
  url?: string;
  type?: "website" | "article";
  noindex?: boolean;
  publishedAt?: string;
  modifiedAt?: string;
}

export type MetadataCollection = {
  seo?: SEOProps;
  jsonLd: Record<string, unknown>[];
};

// A fresh value is created for each server render; the browser uses the null default.
// Collecting existing page metadata avoids a separate, drifting copy of page descriptions.
export const MetadataContext = createContext<MetadataCollection | null>(null);
